import { render, staticRenderFns } from "./top-performers-items.component.vue?vue&type=template&id=584a95f0&scoped=true"
import script from "./top-performers-items.component.vue?vue&type=script&lang=ts"
export * from "./top-performers-items.component.vue?vue&type=script&lang=ts"
import style0 from "./top-performers-items.component.vue?vue&type=style&index=0&id=584a95f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a95f0",
  null
  
)

export default component.exports